const tooltips = {
    'tooltip.edit': 'Bewerken',
    'tooltip.delete': 'Verwijderen',
    'tooltip.login_as': 'Inloggen als',
    'tooltip.activate': 'Activeren',
    'tooltip.deactivate': 'Deactiveren',
    'tooltip.all_products': 'Alle producten',
    'tooltip.sync': 'Synchroniseren',
    'tooltip.category': 'Categorieën',
    'tooltip.brand': 'Merken',
    'tooltip.attributes': 'Attributen',
    'tooltip.price_settings': 'Prijsinstellingen',
    'tooltip.combine': 'Velden koppelen',

    'tooltip.append': 'Meer koppelen',
    'tooltip.create': 'Nieuwe maken',

    'tooltip.product.requires_sync': 'Synchronisatie vereist voor openstaande wijzigingen.',
    'tooltip.product.is_modified': 'Dit product bevat wijzigingen.',

    'tooltip.last_sync': 'Laatste synchronisatie',
    'tooltip.last_update': 'Laatste update',

    'tooltip.allow_custom_subscription_option': 'Type abonnement voor deze klant toestaan.',
    'tooltip.disallow_custom_subscription_option': 'Type abonnement voor deze klant niet (meer) toestaan.',

    'tooltip.subscription_valid_until': 'Abonnement geldig tot:',
};

export default tooltips;
